import { createReducer, on } from '@ngrx/store';
import { startsWith } from 'lodash';
import {
  CategoryVppApplicationsApiActions,
  CategoryVppApplicationsViewActions,
} from './category-vpp-applications.actions';
import { adapter, initialState } from './category-vpp-applications.state';

export const categoryVppApplicationsReducer = createReducer(
  initialState,
  on(CategoryVppApplicationsApiActions.applicationsLoaded, (state, { applications, categoryType, categoryId }) => {
    // Clear store for given category and ids
    const toRemoveLoaded = state.ids
      .map((x) => x.toString())
      .filter((x) => startsWith(x, categoryType) && x.includes(categoryId));
    const intermediateStateLoaded = adapter.removeMany(toRemoveLoaded, state);

    // Add vpp applications to store for given category
    return adapter.addMany(applications, intermediateStateLoaded);
  }),
  on(
    CategoryVppApplicationsViewActions.applicationConfigurationsUpdated,
    (state, { categoryType, categoryId, updatedApplicationsLinkedToCategory }) => {
      // Clear store for given category
      const toRemoveUpdated = state.ids
        .map((x) => x.toString())
        .filter((x) => startsWith(x, categoryType) && x.includes(categoryId));
      const intermediateStateUpdated = adapter.removeMany(toRemoveUpdated, state);

      // Add vpp applications to store for given category
      return adapter.addMany(updatedApplicationsLinkedToCategory, intermediateStateUpdated);
    }
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectCategoryVppApplicationIds = selectIds;

export const selectCategoryVppApplicationEntities = selectEntities;

export const selectAllCategoryVppApplications = selectAll;
